import * as general from './general'
import * as feature from './feature'

export const tariffHelper = {
  general,
  feature,
}
